module.exports = __webpack_public_path__ + "static/signature-white-5924f6e172731d48cc2999c6c047a462.png";